module.exports = __webpack_public_path__ + "img/sudan.ffa71279.png";